import PageHero from '../components/UI/PageHero';
import Services from '../components/Services/Services';
import WhyChooseUs from '../components/WhyChooseUs/WhyChooseUs';
import Process from '../components/Process/Process';
import ContactCTA from '../components/ContactCTA/ContactCTA';
import { IMG } from '../data/siteData';

export default function ServicesPage() {
  return (
    <>
      <PageHero
        eyebrow="What We Move"
        title="Our Transport Services"
        subtitle="Heavy vehicles, trained crews, and route knowledge — built for every kind of cargo across Kerala & Tamil Nadu."
        bg={IMG.warehouse}
      />
      <Services />
      <WhyChooseUs />
      <Process />
      <ContactCTA />
    </>
  );
}
